// Questo file viene popolato automaticamente durante il build da vite.config.ts
// Le variabili __APP_VERSION__ e __BUILD_TIME__ sono definite in vite.config.ts
export const APP_VERSION = (typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0') as string;
export const BUILD_TIME = (typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '') as string;

